import { render, staticRenderFns } from "./t-rent-list.vue?vue&type=template&id=2283643d&scoped=true"
import script from "./t-rent-list.vue?vue&type=script&lang=js"
export * from "./t-rent-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2283643d",
  null
  
)

export default component.exports